import { Close } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import type React from "react";

import type { AttributeFilterProps } from "./types.ts";
import "./attribute-filter.css"

export const Price: React.FC<AttributeFilterProps> = ({ overviewForm }) => {
  return (
    <overviewForm.Field name="Price">
      {(fieldApi) => {
        const value = fieldApi.state.value;
        // Format the display value
        const displayValue = value
          ? Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 0 }).format(
              value,
            )
          : "";

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const inputValue = e.target.value;

          // Remove all non-numeric characters except decimal separators
          const cleanedValue = inputValue.replace(/[^\d.,]/g, "");

          // Parse the cleaned value (handle both comma and dot as decimal separator)
          const parsedValue = cleanedValue.replace(/,/g, ".");
          const numberValue = Number(parsedValue);

          // Only update if it's a valid number
          if (!Number.isNaN(numberValue)) {
            fieldApi.setValue(Math.floor(numberValue)); // Convert to integer for price
          }
        };

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            const target = e.target as HTMLInputElement;
            handleChange({
              target,
              type: "change",
            } as React.ChangeEvent<HTMLInputElement>);
            e.preventDefault();
          }
        };

        return (
          <TextField
            label="Cena do (Kč)"
            fullWidth={true}
            color="secondary"
            size="small"
            variant="filled"
            value={displayValue}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            inputMode="numeric"
            slotProps={{
              input: {
                endAdornment: value ? (
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => {
                      fieldApi.setValue(""); // empty value
                    }}
                  >
                    <Close />
                  </IconButton>
                ) : null,
              },
            }}
          />
        );
      }}
    </overviewForm.Field>
  );
};
